export const SERVICE_UNAVAILABLE_BANNER_DOCUMENT_ID = 'service_unavailability_banner'
export const TERMS_AND_CONDITIONS_BANNER_DOCUMENT_ID = 'terms_and_conditions_banner'
